<template>
  <v-container fluid>
    <!-- <v-navigation-drawer app fixed clipped width="400" >
      <template v-slot:prepend :elevation="3">
        <v-list-item>
          <v-list-item-title>{{ $t("search") }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-slot:append :elevation="3">
        <v-divider></v-divider>
        <div class="d-flex pa-4">
          <v-btn color="primary" class="mr-4" @click="filter()">{{
            $t("apply_filter")
          }}</v-btn>
          <v-btn color="primary" @click="clearFilter()">{{
            $t("cancel")
          }}</v-btn>
        </div>
      </template>

      <div class="pa-2">
        <filter-part ref="filterView"> </filter-part>
      </div>
    </v-navigation-drawer> -->
    <div class="main-container" fill-height>
      <entity-view
        :item-schemas="itemSchemas"
        :items="items"
        :title="$t('service')"
        :pagination="pagination"
        :externalActions="externalActions"
        :options="options"
        @items-refresh="itemsRefresh"
        @item-action="itemAction"
        @page-change="pageChange"
        @double-click-row="clickRow"
      >
      </entity-view>
    </div>
    <v-dialog v-model="dialog" persistent max-width="1200">
      <v-card>
        <v-card-title class="text-h5 ml-6">
          {{ dialogTitle }}
        </v-card-title>
        <v-card-text>
          <form-view
            :itemSchemas="itemSchemas"
            :reverse="false"
            :colPerRow="colPerRow"
            ref="dialogView"
          >
          </form-view>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="
              dialog = false;
              save(action);
            "
          >
            {{ $t("ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("delete_description", [this.selectItem["code"]]) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="
              deleteDialog = false;
              remove();
            "
          >
            {{ $t("ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import FormView from "../components/FormView.vue";
import ProductDropdowns from "../common/product_dropdown";
// import FilterPart from "./FilterPart.vue";

export default {
  components: { EntityView, FormView },
  data: () => ({
    title: "Product",
    select: true,
    expendOpen: false,
    readonly: true,
    dialog: false,
    dialogTitle: "Insert",
    deleteDialog: false,
    selectItem: "",
    action: "insert",
    colPerRow: 1,
    itemSchemas: [
      {
        name: "code",
        value: "code",
        type: "string",
      },
      {
        name: "type",
        value: "type",
        type: "dropdown",
        dropdown: ProductDropdowns.types,
        localized: true,
      },
      {
        name: "subtype",
        value: "subtype",
        type: "dropdown",
        dropdown: function (entity) {
          if (entity["type"] == "review") {
            return ProductDropdowns.reviewSubType;
          } else if (entity["type"] == "analysis") {
            return ProductDropdowns.analysisSubType;
          } else {
            return [];
          }
        },
        localized: true,
      },
      {
        name: "level",
        value: "level",
        type: "dropdown",
        dropdown: ProductDropdowns.levels,
        localized: true,
      },
      {
        name: "amount",
        value: "amount",
        type: "number",
        hasfilter: true,
        condition: {},
      },
    ],
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    items: [],
    externalActions: [],
  }),
  mounted() {
    this.updateSchemaData();
    this.refresh();
  },
  computed: {
    options: function () {
      return {
        dateTimePattern: this.$root.$config.dateTimePattern,
        datePattern: this.$root.$config.datePattern,
        showAction: true,
      };
    },
  },
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
      // this.$refs.filterView.loadSchema(this.itemSchemas);
    },
    refresh() {
      let _this = this;
      // let criterias = this.$refs.filterView.getCriterias();
      let postData = {
        pagination: this.pagination,
        // criterias: criterias,
      };
      this.post("/api/products", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh();
    },
    clickRow(item) {
      this.itemUpdate(item);
    },
    remove() {
      let _this = this;
      let option = {
        callback: function () {
          _this.refresh();
        },
      };
      this.delete("/api/product/" + this.selectItem.code, option);
    },
    itemCreate() {
      this.dialog = true;
      this.action = "insert";
      this.dialogTitle = this.$t("create");
    },
    itemUpdate(item) {
      this.selectItem = item;
      this.$set(this, "dialog", true);
      this.action = "update";
      this.dialogTitle = this.$t("update");
      this.$nextTick(() => {
        this.$refs.dialogView.loadEntity(item);
      });
    },
    itemDelete(item) {
      this.selectItem = item;
      this.deleteDialog = true;
    },
    filter() {
      this.refresh();
    },
    clearFilter() {
      this.$refs.filterView.clear();
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name, item) {
      if (name === "insert") {
        this.itemCreate();
      } else if (name === "update") {
        this.itemUpdate(item);
      }
      if (name === "delete") {
        this.itemDelete(item);
      }
    },
    save(action) {
      let _this = this;
      let entity = this.$refs.dialogView.commitEntity();
      let option = {
        callback: function () {
          _this.refresh();
        },
      };
      if (action == "insert") {
        this.post("/api/product/", entity, option);
      } else if (action == "update") {
        this.put("/api/product/" + entity.code, entity, option);
      }
    },
  },
};
</script>

<style scoped>
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
  "en": {

  },
  "cn": {
  
  }
}
</i18n>
